// Transport-layer request/response encryption has been removed (relying on TLS + JWT).
// `encrypt`/`decrypt` are retained as thin shims so existing call sites keep working:
//  - `encrypt` builds a deterministic string key — used for duplicate-request detection
//    in ApiManager and for local change-detection comparisons in some views.
//  - `decrypt` normalises a now plain-JSON response into a JSON string, so existing
//    `JSON.parse(decrypt(...))` callers keep working whether axios hands back a string
//    or an already-parsed object.
function encrypt(planeText) {
    return JSON.stringify(planeText)
}

function decrypt(code) {
    if (code === null || code === undefined) return code
    // Response is already plain JSON (axios has parsed objects/arrays; primitives arrive raw).
    // Emit a JSON string so the existing `JSON.parse(decrypt(...))` callers round-trip correctly
    // for every type — including bare-string responses like "User require login with 2fa.".
    return JSON.stringify(code)
}

// Session encryption moved to @sumtl/shared so both front ends read the same blob (ARCH-17).
// Re-exported here because six modules already import it from this path.
export { encryptSession, decryptSession } from '../../../shared/session-crypto.js'

export {
    encrypt,
    decrypt,
}
